const topicsData = [
  { tag: '#顶流塌房', heat: '1289万讨论', active: true },
  { tag: '#网红翻车实录', heat: '967万讨论', active: true },
  { tag: '#综艺内幕曝光', heat: '854万讨论', active: false },
  { tag: '#明星离婚大瓜', heat: '732万讨论', active: true },
  { tag: '#选秀暗箱操作', heat: '689万讨论', active: false },
  { tag: '#直播带货翻车', heat: '621万讨论', active: false },
  { tag: '#娱乐圈资本局', heat: '578万讨论', active: false },
  { tag: '#粉丝经济泡沫', heat: '493万讨论', active: false },
  { tag: '#海外八卦速递', heat: '412万讨论', active: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            大家都在讨论的热门话题，点击加入吃瓜大军
          </p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
          {topicsData.map((item, idx) => (
            <div
              key={idx}
              className={`inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full cursor-pointer transition-all duration-200 ${
                item.active
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{item.tag}</span>
              <span className={`text-xs whitespace-nowrap ${item.active ? 'text-background-50/70' : 'text-foreground-400'}`}>
                {item.heat}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-400">
            以上话题热度数据基于全网公开讨论量统计，每小时自动更新一次
          </p>
        </div>
      </div>
    </section>
  );
}